<template>

  <div class="md-layout" style="height: 100%;z-index: 999">
    <div class="chat-bot-header">
      <center>
        <span>这是一个纸条情感树洞机器人</span><br/>
        <span>让树洞见证你的故事，让友谊在匿名的交流中绽放。</span><br/>
        <span>在这里，你可以真实地表达自己，而不用担心被评判。</span>
      </center>
    </div>

    <div style="width: 10px"></div>
    <div class="md-layout-item">
      <div class="chat-list" ref="chatList">
        <md-list v-for="item in messages" :key="item.index">

          <md-list-item v-if="item.type === 'user'">
            <div class="md-elevation-1" style="width: 100%; padding: 0px 10px 0px 10px; border-radius: 10px; margin-right: 10px">
              <p style="white-space: normal">
                {{ item.content }}
              </p>
            </div>
            <md-avatar>
              <img src="../assets/people.png" alt="Avatar">
            </md-avatar>

          </md-list-item>

          <md-list-item v-else-if="item.type === 'assistant'">
            <md-avatar>
              <img src="../assets/tongyi.png" alt="Avatar">
            </md-avatar>
            <div class="md-elevation-1" style="width: 100%; border-radius: 10px;padding: 0px 10px 0px 10px">
              <p style="white-space: normal">
                {{ item.content }}
              </p>
            </div>
          </md-list-item>
        </md-list>
      </div>

      <div class="chat-input">
        <md-field>
          <md-textarea style="resize: none" placeholder="请输入您想问的问题，我们不会存储您的任何信息" v-model="prompt" @keydown.enter="onInputClicked">

          </md-textarea>
          <md-button class="md-icon-button" v-on:click="onInputClicked">
            <md-icon>arrow_forward</md-icon>
            <!--            <md-icon>stop</md-icon>-->
          </md-button>
        </md-field>
      </div>

      <md-snackbar :md-position="'center'" :md-duration="3000" :md-active.sync="snackbarShow" md-persistent>
        <span>{{snackbarContent}}</span>
      </md-snackbar>
    </div>


    <div style="width: 10px"></div>

    <!--  底部  -->
    <div class="chat-bot-bottom">
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024235290号-1</a>
      <br />
      <span>Copyright © 2024-2024 深圳市雷狐互联科技有限公司 All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>
  import {fetchEventSource} from "@microsoft/fetch-event-source"
  export default {
    name: "Index",
    data() {
      return {
        generating: false,
        prompt: "",
        sessionId: "",
        messages: [],
        snackbarShow: false,
        snackbarContent: "",
      }
    },
    methods: {
      scrollToBottom() {
        this.$nextTick(()=>{
          const chatList = this.$refs.chatList;
          chatList.scrollTop = chatList.scrollHeight;
        });
      },

      onInputClicked() {
        if(this.prompt.length === 0) {
          console.log("prompt is empty!");
          return;
        }

        if(this.generating === true) {
          console.log("assistant generating!");
          return;
        }

        this.messages.push({index: this.messages.length, type: "user", content: this.prompt});
        this.messages.push({index: this.messages.length, type: "assistant", content: "正在回答..."});

        const self = this;
        const abortController = new AbortController()
        const url = "https://api.cavity.leihu.top/v1/completions";
        // const url = window.location.protocol + "//" + window.location.host + "/v1/completions";

        fetchEventSource(url, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            prompt: this.prompt,
            sessionId: this.sessionId,
          }),
          signal: abortController.signal,
          onmessage(msg) {
            console.log(msg.data);
            let data = JSON.parse(msg.data);

            if(data["success"] === true) {
              self.messages[self.messages.length-1].content = data["data"]["text"];

              if(self.generating === false) {
                self.generating = true;
                self.prompt = "";
              }

              if(data["data"]["finishReason"] === "stop") {
                self.sessionId = data["data"]["sessionId"];
                self.generating = false;
              }
            } else {
              /*
                {
                    "statusCode": 400,
                    "message": "Input or output data may contain inappropriate content.",
                    "code": "DataInspectionFailed",
                    "isJson": true,
                    "requestId": "374c23f1-d659-90f4-985c-217429241d47"
                }
              */
              let errorMsg = JSON.parse(data["errorMsg"]);

              if (errorMsg["statusCode"] === 400) {
                self.snackbarContent = "输入或输出数据可能包含不适当的内容。";
              } else {
                self.snackbarContent = errorMsg[message];
              }
              self.snackbarShow = true;
            }

            self.scrollToBottom();
          },
          onerror(error) {
            console.log(error);
          },
          onclose() {
            console.log("http sse close!");
          },
        });
      },
    },
  }
</script>

<style scoped>
.md-layout-item{
  max-height: 100%;
}

.chat-list{
  margin-top: 100px;
  min-height: 62%;
  max-height: 62%;
  overflow-y: auto;
}

.chat-list::-webkit-scrollbar {
  display: none; /* 不显示滚动条 */
}

.chat-bot-header {
  position: fixed;
  width: 100%;
  height: 100px;
  background: linear-gradient(to right, #1791ee, #9fdbf1);
  color: white;
  text-align: center;
  padding: 15px;
  font-size: 14px;
  font-weight: 600;
  z-index: 999;
}

.chat-input{
  position: relative;
  z-index: 998;
  background-color: white;
}

.chat-bot-bottom{
  position: fixed;
  bottom: 10px;
  text-align: center;
  width: 100%;
  height: 65px;
  overflow-y: auto;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue